import React, { useState, useEffect } from "react";
import Adminfooter from "../Shared/Adminfooter";
import Adminnavbar from "../Shared/Adminnavbar";
import Adminsidebar from "../Shared/Adminsidebar";
import Swal from "sweetalert2";
import config from "../../config";
import { useNavigate } from "react-router-dom";

function Classxnotice() {
  const [loading, setLoading] = useState(true);
  const [showingDate, setShowingDate] = useState("");
  const [noticeFile, setNoticeFile] = useState(null);
  const [description, setDescription] = useState("");
  const [noticeList, setNoticeList] = useState([]);
  const [editId, setEditId] = useState(null);
  const [noticePreviewUrl, setNoticePreviewUrl] = useState(null);
  const [existingFileUrl, setExistingFileUrl] = useState("");
  useEffect(() => {
    fetchNotices();
  }, []);
  const navigate = useNavigate();
  useEffect(() => {
    const token = sessionStorage.getItem("tokenadminxii");

    if (!token) {
      navigate("/admin-login");
      return;
    }
  })
  const fetchNotices = async () => {
    try {
      const token = sessionStorage.getItem("tokenadminxii");
      const response = await fetch(
        `${config.API_BASE_URL}/SelectNoticeDataClass12`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      console.log("Fetched notice data:", data);
      setLoading(false);
      if (Array.isArray(data.data?.["select-notice"])) {
        setNoticeList(data.data?.["select-notice"]);


      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching notice list:", error);
      setNoticeList([]);
    }
  };

  const validateForm = () => {
    if (!showingDate) return false;
    if (!noticeFile) return false;
    if (!description.trim()) return false;
    return true;
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type !== "application/pdf") {

      Swal.fire("Warning", "Only PDF files are allowed!", "warning");
      setNoticeFile(null);
      setNoticePreviewUrl(null);
      e.target.value = "";
      return;
    }
    if (file) {

      setNoticeFile(file.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result.split(",")[1];
        const fileUrl = URL.createObjectURL(file);
        // console.log("File URL:", fileUrl);
        // console.log("Base64:", base64);
        setExistingFileUrl(base64);
        setNoticePreviewUrl(fileUrl);
      };
      reader.readAsDataURL(file);
    } else {

      setNoticeFile(null);
      setExistingFileUrl("");
      setNoticePreviewUrl("");
    }
  };


  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    if (!validateForm()) {
      if (!showingDate) {
        Swal.fire("Warning", "Please enter Showing Date", "warning");
      } else if (!noticeFile) {
        Swal.fire("Warning", "Please upload Notice file", "warning");
      } else if (!description.trim()) {
        Swal.fire("Warning", "Please enter Description", "warning");
      }
      setLoading(false);
      return;
    }

    try {
      const token = sessionStorage.getItem("tokenadminxii");

      const response = await fetch(
        `${config.API_BASE_URL}/InsertUpdateNoticeClass12`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            id: editId || null,
            noticE_DESCRIPTION: description,
            noticE_FILE: noticeFile,
            file_Base64String: existingFileUrl,
            showinG_DATE: showingDate,
          }),
        }
      );

      if (response.ok) {
        const message = editId ? "Notice updated successfully!" : "Notice uploaded successfully!";
        Swal.fire("Success", message, "success");
        setShowingDate("");
        setNoticeFile(null);
        setDescription("");
        setEditId(null);
        setNoticePreviewUrl(null);
        if (document.getElementById("noticeFileInput")) {
          document.getElementById("noticeFileInput").value = "";
        }
        fetchNotices();
      } else {
        Swal.fire("Warning", "Failed to upload notice", "warning");
      }
      setLoading(false);

    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Warning", "An error occurred while uploading", "warning");
      setLoading(false);
    }
  };


  const handleEdit = async (id) => {
    setLoading(true);
    const token = sessionStorage.getItem("tokenadminxii");
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/EditNoticeDataClass12`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ id }),
        }
      );
      const data = await response.json();
      console.log("Fetched notice data for edit:", data);
      if (response.ok) {
        const notice = data.data["edit-notice"][0];

        setEditId(notice.ID || "");
        setDescription(notice.NOTICE_DESCRIPTION || "");
        setShowingDate(notice.SHOWING_DATE || "");
        setNoticeFile(notice.NOTICE_FILE_NAME || "");
        //setExistingFileUrl(notice.NOTICE_FILE_URL || "");
        setExistingFileUrl("");
        setNoticePreviewUrl(notice.NOTICE_FILE_URL || "");

      } else {
        Swal.fire("Warning", "Failed to fetch notice for edit", "warning");
      }
    } catch (error) {
      Swal.fire(
        "Warning",
        "An error occurred while fetching notice for edit",
        "warning"
      );
    }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to delete this notice?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const token = sessionStorage.getItem("tokenadminxii");
        try {
          const response = await fetch(
            `${config.API_BASE_URL}/DeleteNoticeDataClass12`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({ id }),
            }
          );
          if (response.ok) {
            Swal.fire("Success", "Notice deleted successfully!", "success").then(() => {
              window.location.reload();
            });
            setShowingDate("");

            setNoticeFile(null);
            setDescription("");
            setNoticePreviewUrl(null);
            setEditId(null);
            setExistingFileUrl("");
            if (document.getElementById("noticeFileInput")) {
              document.getElementById("noticeFileInput").value = "";
            }

          } else {
            Swal.fire("Warning", "Failed to delete notice", "warning");
          }
        } catch (error) {
          console.error("Error deleting notice:", error);
          Swal.fire("Warning", "An error occurred while deleting", "warning");
        }
      }
    });
  };



  return (
    <>
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div class="container-scroller">
        <Adminnavbar />
        <div class="container-fluid page-body-wrapper">
          <Adminsidebar />
          <div class="main-panel">
            <div class="content-wrapper">
              <div class="row">
                <div class="col-lg-5 col-m-12 mb-4 ">
                  <div class="card">
                    <div class="card-header bg-brown">
                      <h5 class="mb-0 p-2">Upload Notice ( Class XII )</h5>
                    </div>
                    <div class="card-body">
                      <div class="row">
                        <div class="col-lg-5 col-m-12">
                          <div class="form-group mb-3">
                            <label>
                              Date <span class="text-danger">*</span>
                            </label>
                            <input
                              type="date"
                              class="form-control form-control-sm"
                              value={showingDate}
                              onChange={(e) => setShowingDate(e.target.value)}
                              // min={new Date().toISOString().split("T")[0]}
                              onKeyDown={(e) => e.preventDefault()}
                            />
                          </div>
                        </div>
                        <div class="col-lg-7 col-m-12">
                          <div class="form-group mb-3">
                            <label>
                              Upload Notice <span class="text-danger">*</span>
                            </label>
                            <div className="d-flex align-items-center">
                              <input
                                type="file"
                                accept="application/pdf"
                                name="noticeFileInput"
                                id="noticeFileInput"
                                className="d-none"
                                onChange={(e) => handleFileChange(e)}
                              />
                              <label
                                htmlFor="noticeFileInput"
                                className="custom-file-uploader btn btn-sm btn-outline-primary"
                                style={{ width: "220px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                              >
                                <i className="fa fa-upload"></i> &nbsp;
                                {noticeFile ? noticeFile : "Choose File"}
                              </label>
                              {noticePreviewUrl && (
                                <a
                                  href={noticePreviewUrl || ""}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-sm btn-outline-secondary ms-2 eyeicon"
                                  title="Preview Notice"
                                  style={{ height: "40px", display: "flex", alignItems: "center" }}
                                >
                                  👁️
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-12 col-m-12">
                          <div class="form-group mb-3">
                            <label>
                              Description <span class="text-danger">*</span>
                            </label>
                            <textarea
                              class="form-control form-control-sm"
                              rows="3"
                              placeholder="Enter Description"
                              value={description}
                              onChange={(e) => setDescription(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-secondary me-2"
                          onClick={() => {
                            setShowingDate("");
                            setNoticeFile(null);
                            setDescription("");
                            setNoticePreviewUrl(null);
                            setExistingFileUrl(""); // <-- Add this line
                            if (document.getElementById("noticeFileInput")) {
                              document.getElementById("noticeFileInput").value = "";
                            }
                          }}
                          disabled={loading}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary"
                          onClick={handleSubmit}
                          disabled={loading}
                        >
                          {loading ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-7">
                  <div className="card">
                    <div className="card-header bg-brown">
                      <h5 className="mb-0 p-2">Notice List</h5>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table table-bordered table-sm">
                          <thead>
                            <tr>
                              <th>Sl No.</th>
                              <th>Date</th>
                              <th>File View</th>
                              <th>Description</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {noticeList.length === 0 ? (
                              <tr>
                                <td colSpan="5" className="text-center">
                                  No records found
                                </td>
                              </tr>
                            ) : (
                              noticeList.map((notice, index) => (
                                <tr key={notice.ID || index}>
                                  <td>{index + 1}</td>
                                  <td>
                                    {(notice.SHOWING_DATE || notice.showinG_DATE)?.split('-').reverse().join('-')}
                                  </td>
                                  <td>
                                    {notice.NOTICE_FILE_NAME ? (
                                      <a
                                        href={notice.NOTICE_FILE_URL ? notice.NOTICE_FILE_URL : process.env.PUBLIC_URL + "/assets/images/no-image.png"}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-link p-0"
                                      >
                                        {notice.NOTICE_FILE_NAME || "No image"}
                                      </a>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    {notice.NOTICE_DESCRIPTION ||
                                      notice.noticE_DESCRIPTION}
                                  </td>
                                  <td style={{ width: "150px" }}>
                                    <button
                                      className="btn btn-xs btn-primary me-2"
                                      type="button"
                                      onClick={() =>
                                        handleEdit(notice.ID)
                                      }
                                    >
                                      <i className="fa fa-edit me-2"></i>
                                      Edit
                                    </button>
                                    <button
                                      className="btn btn-xs btn-danger me-2"
                                      type="button"
                                      onClick={() =>
                                        handleDelete(notice.ID)
                                      }
                                    >
                                      <i className="fa fa-trash me-2"></i>
                                      Delete
                                    </button>

                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Adminfooter />
          </div>
        </div>
      </div>
    </>
  );
}

export default Classxnotice;
